export default __webpack_public_path__ + "static/media/WindSpeed.19dd979b.svg";